import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { BaseHttpService } from '@framework/services';
import { GetStoryInputApiModel } from '@modules/company-admin/store/models/api-models/input/get-story-input.api-model';



@Injectable()
export class ReminderHttpService extends BaseHttpService {

    constructor(httpClient: HttpClient) {
        super(httpClient, '/');
    }

    public postReminder(payload: any) {
        return this.post('/stories/reminders/', payload).pipe(
            map((response: any) => {
                return  response;
            })
        );
    }

    public getReminder(id,query: GetStoryInputApiModel) {
        return this.get(`/companies/${id}/setting/reminders/?${query.query}`).pipe(
            map((response: any) => {
                return  response;
            })
        );
    }
}